import { colors } from '@ch/common/const/color';
import { font } from '@ch/common/const/font';
import styled from 'styled-components';

export const HomeImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export const HomeReportHTMLContent = styled.div`
  color: ${colors.primary};
  & strong {
    font-family: ${font.family.aeonikBold};
  }
`;

export const HomeContactHTMLContent = styled.div`
  color: ${colors.primary};
  & strong {
    font-family: ${font.family.aeonikBold};
  }
`;
